import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getDefaultSettings } from "../../../Redux/actions/defaultSettingsActions";
import {
  Home_2,
  scrollx_icon,
  Settings,
  SyncNav,
  CreditsNav,
  NotificationsIcon,
  Brandicon,
  user_2,
  HomeIcon_whiteFill,
  BackArrowIcon2,
  scrollxLogo
} from "../../../assets/icons/index";
import {
  updateProjectCreditsByGoogle,
  updateProjectCredits,
} from "../../../Redux/actions/projectActions";
import { read, utils } from "xlsx";
import { excelDataToCredits } from "../../../services/excelDataToProjectData";
import { Button_2, FileInput_2 } from "../../../Components";
import "./Navbar_1.css";
import Setting from "../../Setting/Setting";
import CustomToast from "../../../Components/CustomToast/CustomToast";
import {
  customToatStyle,
  customToatStyleError,
} from "../../../Components/CustomToast/CustomToast";
import {
  addNotifications,
  deleteNotifications,
  getNotification,
  updateNotification,
} from "../../../Redux/actions/commonActtion";
import { DropdownForNotiFy } from "../../../Components";
const getUpdatedProjectCredits = (currentCredits, newCredits) => {
  try {
    const updatedCredits = newCredits;
    for (let i = 0; i < newCredits.length; i++) {
      let idx = currentCredits.findIndex(
        (credit) =>
          credit.options.block_name == newCredits[i].options.block_name
      );
      if (
        idx !== -1 &&
        currentCredits[idx].options.block_type ==
          newCredits[i].options.block_type
      ) {
        updatedCredits[i].options = currentCredits[idx].options;
      }
    }
    return { data: updatedCredits };
  } catch (error) {
    // console.log(error);
    return { error, data: null };
  }
};

export default function Navbar_1({
  titleName,
  savedSaving,
  setReLoading,
  isRederFinished,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isSettingOpen, setIsSettingOpen] = useState(false);
  const [isShareOpen, setIsShareOpen] = useState(false);
  const [isOptionsVisible, setIsOptionsVisible] = useState(false);
  const project = useSelector((state) => state.project);
  const {
    googleSheetLink,
    _id,
    googleSpreadSheetId,
    credits: currentCredits,
    currentBlock,
  } = useSelector((state) => state?.project);
  const notifications = useSelector(
    (state) => state.commonReducer.notifications
  );
  const notificationsWithReadStatus = useSelector(
    (state) => state.commonReducer.notificationsWithReadStatus
  );
  let notificationsLentgh = notificationsWithReadStatus
    ? notificationsWithReadStatus.length
    : 0;

  useEffect(() => {
    fetchProjectSettings();
    dispatch(getNotification());
  }, []);

  const fetchProjectSettings = () => {
    dispatch(getDefaultSettings());
  };

  const CloseButton = ({ closeToast }) => (
    <i
      className="material-icons w-7 flex justify-center cursor-pointer"
      onClick={closeToast}
      style={{ fontStyle: "normal" }}
    >
      ✖
    </i>
  );
  const handleGoogleUpdate = async () => {
    await setReLoading({ condn: true, label: "Syncing..." });

    try {
      const res = await dispatch(
        updateProjectCreditsByGoogle(_id, googleSpreadSheetId, currentCredits)
      );
      // console.log('Synch Response = ', res?.response?.data);
      if (res?.success === true) {
        await setReLoading({ condn: false, label: "" });
        setTimeout(() => {
          toast(
            <CustomToast title="" content={res?.message} />,
            customToatStyle
          );
        }, 100);
      } else {
        await setReLoading({ condn: false, label: "" });
        setTimeout(() => {
          toast(
            <CustomToast
              title={res?.response?.data?.title}
              content={res?.response?.data?.message}
            />,
            customToatStyleError
          );
        }, 300);
      }
    } catch (err) {
      await setReLoading({ condn: false, label: "" });
      // console.log(err);
    }
  };
  const handleFileInput = (file) => {
    try {
      const reader = new FileReader();
      reader.onload = (evt) => {
        const binaryStr = evt.target.result;
        const wb = read(binaryStr, { type: "binary" });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const jsonData = utils.sheet_to_json(ws, { header: 1 });
        const newCredits = excelDataToCredits(jsonData);
        const { data: updatedCredits, error } = getUpdatedProjectCredits(
          currentCredits,
          newCredits
        );
        if (error) {
          return error;
        }
        dispatch(updateProjectCredits(_id, updatedCredits));
      };
      reader.readAsBinaryString(file);
    } catch (err) {
      return err;
    }
  };
  const getAllNotification = async () => {
    if(notificationsLentgh > 0){
       await dispatch(updateNotification()).then(() => {
          notificationsLentgh = notificationsWithReadStatus.length;
       });
    }
    setIsOptionsVisible(true);
    await dispatch(getNotification());
  };
  const fetchData = async (arg) => {};
  const handleDeleteNotification = async (id) => {
    await dispatch(deleteNotifications({ notification_id: id }));
  };

  return (
    <>
      <nav id="navbar_1" className="w-full">
        <ToastContainer closeButton={CloseButton} />

        <div className="Pro_navbar px-2">
          <div className="flex items-center ">
            <Link className="flex items-center" to="/dashboard">
            <img
            className="pl-[14px]  w-[49px]"
            src={BackArrowIcon2}
            alt=""
            style={{ cursor: "pointer" }}
          />
              <img className="pro_navabr_home2 " src={scrollxLogo} />
              <h1 className="Syne text-xl font-extrabold tracking-wide ">
              {" "}
              ScrollX.io
            </h1>
            </Link>
            
          </div>

          <div className="xl:mr-[3%] 2xl:mr-[10.5%] navbarProjectName flex items-center justify-start">
            {/* <img className="pro_navabr_scrollx_icon" src={scrollx_icon} /> */}
            <div className="  FontFamily-Avenir-reg text-base tracking-wide  flex items-center justify-center text-white">
              {project?.title?.toUpperCase()}
              {/* <span className="d-none ml-3 text-lg text-center text-zinc-300 mt-[1px]">🠛</span> */}
            </div>
          </div>

          <div className="flex justify-center ">
            <div className="flex  left_side_width  justify-center">
              <p className="">{savedSaving}</p>
              <div
                className="ProNavbarButton mr-[20px] flex items-center justify-center  border-[1px] border-[#54606c] px-2 w-24 xl:w-28 py-[4px] rounded-2xl  "
                type="button"
                onClick={() => window.open(googleSheetLink)}
              >
                {/* <div className="w-full flex items-center justify-center  relative "> */}
                  {/* <img src={CreditsNav} className="pro_navabr_Credits_logo pb-1" /> */}
                  <h1 className="text-center text-white  FontFamily-Avenir-reg text-[14px] tracking-widest uppercase pt-[2px]">
                    Credits
                  </h1>
                {/* </div> */}
              </div>
              {googleSheetLink ? (
                <div
                  className="ProNavbarButton flex items-center   justify-center  border-[1px] border-[#54606c] px-2 w-24 xl:w-24 py-[4px] rounded-2xl  "
                  type="button"
                  onClick={handleGoogleUpdate}
                >
                  {/* <div className="w-full flex items-center justify-center  "> */}
                    {/* <img className="pro_navabr_reload_logo pb-1" src={SyncNav} /> */}
                    <h1 className="text-center text-white FontFamily-Avenir-reg text-[14px] tracking-widest uppercase inline-block pt-[2px]">
                      Sync
                    </h1>
                  {/* </div> */}
                </div>
              ) : (
                <div
                  className="ProNavbarButton flex items-center   justify-center  border-[1px] border-[#a1a1a2] px-2 w-24 xl:w-24 py-[4px] rounded-2xl "
                  accept=".xls,.xlsx"
                  handleFileInput={handleFileInput}
                >
                  {/* <img className="pro_navabr_reload_logo pb-1" src={SyncNav} /> */}
                  <h1 className="text-center text-white FontFamily-Avenir-reg text-[14px] tracking-widest uppercase inline-block pt-[2px]">
                    Sync
                  </h1>
                </div>
              )}
            </div>

            <div className="flex items-center ml-2 pr-[22px]">
              {/* <div className="flex  m-auto  ">
                <button onClick={() => setIsShareOpen(true)}><img src={Share_2} className="pro_navabr_Share_2" /></button>
                <img src={Share_2} style={{ width: "30px" }} />
              </div> */}
              {/* <div className="flex  m-auto  ml-3">
                <img src={activity} className="pro_navabr_activity" />
              </div> */}
              <div className="flex  m-auto  px-1 notification ">
                <button>
                  <img
                    src={NotificationsIcon}
                    onClick={getAllNotification}
                    className="pro_navabr_Notifications opacity-75  "
                  />
                </button>
                {notificationsLentgh > 0 && (
                  <button class="badge">{notificationsLentgh}</button>
                )}
              </div>
              <div className="flex  m-auto  pl-2 ">
                <button onClick={() => setIsSettingOpen(true)}>
                  <img src={user_2} className="pro_navabr_Settings opacity-75" />
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="">
          <Setting
            isSettingOpen={isSettingOpen}
            setIsSettingOpen={setIsSettingOpen}
          />
          <DropdownForNotiFy
            isOptionsVisible={isOptionsVisible}
            setIsOptionsVisible={setIsOptionsVisible}
            options={notifications}
            notificationsLentgh={notificationsLentgh}
            fetchMoreData={fetchData}
            handleDeleteNotification={handleDeleteNotification}
          />
        </div>
      </nav>
    </>
  );
}